
function setOrders({commit}, data) {
  commit('setOrders', data);
};

function updateOrder({commit}, data) {
  commit('updateOrder', data);
}

function deleteOrder({commit}, data) {
  commit('deleteOrder', data);
}

function setCancellingOrders({commit}, data) {
  commit('setCancellingOrders', data);
}

function deleteCancellingOrder({commit}, data) {
  commit('deleteCancellingOrder', data);
}

function editCancellingOrder({commit}, data) {
  commit('editCancellingOrder', data);
}

function setPendingPurchases({commit}, data) {
  commit('setPendingPurchases', data);
}

export default {
  setOrders,
  updateOrder,
  deleteOrder,
  setCancellingOrders,
  deleteCancellingOrder,
  editCancellingOrder,
  setPendingPurchases,
}
